var React = require('react');

function CarrotLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 7L2.21434 6.76191L6.47155 2L7 2.47619L2.95713 7L7 11.5238L6.47155 12L2.21434 7.2381L2 7Z","fill":"currentColor","stroke":"currentColor","strokeWidth":"2"}));
}

CarrotLeft.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14","fill":"none"};

module.exports = CarrotLeft;

CarrotLeft.default = CarrotLeft;
